import { render, staticRenderFns } from "./stepComponent.vue?vue&type=template&id=384bb967&scoped=true"
import script from "./stepComponent.vue?vue&type=script&lang=js"
export * from "./stepComponent.vue?vue&type=script&lang=js"
import style0 from "./stepComponent.vue?vue&type=style&index=0&id=384bb967&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384bb967",
  null
  
)

export default component.exports